import React from 'react';

interface ControlledToggleButtonProps {
  isOn: boolean;
  onToggle: () => void;
  disabled?: boolean;
  className?: string;
}

export const ControlledToggleButton: React.FC<ControlledToggleButtonProps> = ({
  isOn,
  onToggle,
  disabled = false,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm font-medium text-gray-400 min-w-[30px] text-right">
        {isOn ? 'ON' : 'OFF'}
      </span>
      
      <button
        onClick={onToggle}
        disabled={disabled}
        className={`relative w-16 h-8 rounded-full transition-all duration-300 ease-in-out ${
          isOn 
            ? 'bg-gradient-to-r from-green-400 to-emerald-500 shadow-lg shadow-green-500/50' 
            : 'bg-gray-300'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        aria-label="Toggle switch"
      >
        <span
          className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300 ease-in-out ${
            isOn ? 'translate-x-8' : 'translate-x-0'
          }`}
        >
          {isOn && (
            <svg 
              className="w-6 h-6 text-green-500 p-1" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={3} 
                d="M5 13l4 4L19 7" 
              />
            </svg>
          )}
          {!isOn && (
            <svg 
              className="w-6 h-6 text-gray-400 p-1.5" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={3} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          )}
        </span>
      </button>
    </div>
  );
};
